/** A failed refresh-token renewal; `status` is the HTTP status, absent when none was received (network error, bad body) */
export class TokenRefreshError extends Error {
  readonly status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'TokenRefreshError';
    this.status = status;
  }
}

/** pm_ums rejects a refresh token with 400 (401 is accepted too); any other failure is transient */
export const isRejectedRefresh = (error: unknown): boolean =>
  error instanceof TokenRefreshError && (error.status === 400 || error.status === 401);
